import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import React from 'react';
import { Heading, Icon, Notice, Separator, Table, TableRow } from 'telia-front-react';
import PrivateMobileDetailsTableCell from './PrivateMobileDetailsTableCell';

const PrivateMobileNetflix = observer(() => {
  const { translate } = React.useContext(TranslationsContext);

  const renderTableRow = (detailIcon: string, detailName: string): React.JSX.Element => (
    <TableRow>
      {detailIcon && (
        <PrivateMobileDetailsTableCell width={1} padding="none">
          <Icon modifiers={`#${detailIcon}`} size="sm" />
        </PrivateMobileDetailsTableCell>
      )}
      <PrivateMobileDetailsTableCell width={detailIcon ? 11 : 12} padding={!detailIcon ? 'none' : 'default'} colSpan={!detailIcon ? 2 : 1}>
        {translate(`mobile.details.netflix.${detailName}`)}
      </PrivateMobileDetailsTableCell>
    </TableRow>
  );

  return (
    <>
      <Heading level={1} className="h4 text-bold">
        {translate('mobile.details.netflix.title')}
      </Heading>
      <Separator spacing="xxsmall" color="strong" weight="thin" />
      <Table>
        <tbody>
          {renderTableRow(null, 'account')}
          {renderTableRow('tv-viewslot', 'viewslot')}
          {renderTableRow('tv-screen', 'hd')}
          {renderTableRow('file-bill', 'invoice')}
        </tbody>
      </Table>
      <Separator color="invisible" spacing="xxsmall" />
      <Notice size="small">{translate('mobile.details.netflix.languageNotice')}</Notice>
    </>
  );
});

export default PrivateMobileNetflix;
